/**
 * Created by mauget on 3/1/16.
 */

// OpenViewableInstanceDetailView.js

import $ from 'jquery';
import restService  from 'RestService.js';
import {View, Model} from 'backbone';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/forms/viewable-instance-view.ejs';
import RestService from 'RestService.js';
import eventBus         from 'EventBus.js';
import BaseTableView from 'properties/BaseTableView.js'
import util from 'util/Util.js';
import configService  from 'ConfigService';

class ViewableInstanceDetailView extends BaseTableView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            'change select': 'updateFilters',
            'change input[type="text"]':'updateNameSearch',
            'click #view-instance':'viewInstanceDetails',
            'click #new-instance' : 'createNewInstanceForm',
            'click #view' : 'view', 
            'click #goToForms': 'goToForms'
        };

        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        this.model.set({
            colModel: [
                {
                    name: 'id',
                    index: 'id',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'name',
                    index: 'name',
                    editable: false
                },
                {
                    name: 'attentionLevel',
                    index: 'attentionLevel',
                    editable: false
                },
                {
                    name: 'anyone',
                    index: 'anyone',
                    editable:false
                },
                {
                    name: 'stage',
                    index: 'stage',
                    editable:false
                },
                {
                    name: 'status',
                    index: 'status',
                    editable: false
                },
                {
                    name: 'formInstanceId',
                    index: 'formInstanceId',
                    editable: false,
                    hidden: true
                }

            ],
            colNames: ['Id','Name', 'AttentionLevel', 'Anyone','Stage','Status', 'formInstanceId']
        });

        this.listenTo(this.model, 'change', this.render);
        this.onResize();
        return this;
    }

    goToForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadFormsView");
    }

    view() {
        const selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        const rowData = $(this.gridEl).getRowData(selRowId);

        const instanceUrl = restService.getLinkUrl(rowData['formInstanceId']) + '&viewForm=true';
        const attributes = {url: instanceUrl, id: rowData['formInstanceId'] };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

    createNewInstanceForm() {
        const url = this.model.get('LinkId')+'&viewForm=true';
        this.playForm(url, false);
    }

    playForm(id) {
        
        let instanceUrl = this.hostUrl + '/player.htm?f=' +  id;
        const attributes = { url: instanceUrl, id: id };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        let formId = this.model.get('formId');

        newPlayForm.render().then((result) => {});
    }

    // Method that performs an API Call whenever one of the dropdown values are changed.
    updateFilters(event) {
        let targetValue = event.target.value;

        // If the element has an extra .5 as a value then an OrHigher value was selected so we save it into the model.
        if (event.target.value.includes('.5')) {
            this.model.set('search-' + event.target.name + 'OrHigher', 'true');
            targetValue=targetValue.split('.')[0];
        } else {
            this.model.set('search-' + event.target.name + 'OrHigher', '');
        }
        // Saving the attention level value.
        this.model.set('search-' + event.target.name, targetValue);
        this.performSearch();
    }

    // Method that performs an API Call whenever the filter text changes.
    updateNameSearch(event) {
        let targetValue=event.target.value;
        this.model.set('search-' + event.target.name, targetValue+'%');
        this.performSearch();
    }

    // Method that performs the general search by gathering all of the values saved into the model through the form.
    performSearch() {
        const status = this.model.get('search-status') || '-1';

        // As the API needs another parameter to set it with a higher category,
        // it is required to set it in another attribute inside the model.
        const attentionLevel = this.model.get('search-attentionLevel') || '-1';
        const attentionLevelOrHigher = this.model.get('search-attentionLevelOrHigher') || 'false';

        const otherAttentionLevel = this.model.get('search-otherAttentionLevel') || '-1';
        const otherAttentionLevelOrHigher = this.model.get('search-otherAttentionLevelOrHigher') || 'false';

        const instanceName = this.model.get('search-instanceName') || '%';
        const formId = this.model.get('formId');
        const formName = this.model.get('formName');
        RestService.searchViewableFormInstanceDetails(
            formId,
            instanceName,
            status,
            attentionLevel,
            attentionLevelOrHigher,
            otherAttentionLevel,
            otherAttentionLevelOrHigher).then((data)=> {

            const viewableDetails = data.RESULT.RESPONSE;
            this.model.set('owner', viewableDetails.OwnerName, {silent: true});
            this.model.set('ownerId', viewableDetails.OwnerId, {silent: true});
            this.model.set('lastUpdate', viewableDetails.DeployDate, {silent: true});
            this.model.set('lastVersion', viewableDetails.DeployVersion, {silent: true});
            this.model.set('formId', formId, {silent: true});
            if (viewableDetails.InstanceList) {
                let instances = viewableDetails.InstanceList.Instance instanceof Array
                    ? viewableDetails.InstanceList.Instance
                    : [viewableDetails.InstanceList.Instance];
                this.model.set('instances', instances, {silent: true});
                this.model.set('gridData', instances, {silent: true});
            }
            else {
                this.model.set('instances', [], {silent: true});
                this.model.set('gridData', [], {silent: true});
            }

            // Configure Title and Breadcrumbs
            var breadcrumbs = [
                {name: 'Home', route: '#forms'},
                {name: 'Apps', route: '#forms'},
                {name: formName, route: ''}
            ];

            this.model.set('dashboardTitle', 'App - ' + formName, {silent: true});
            this.model.set('breadcrumbs', breadcrumbs, {silent: true});

            this.render();

        });
    }
    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    onCellSelect(rowId, iCol, cellContent,e){
        $(this.gridEl).jqGrid('setSelection',rowId);
        $("#view-instance").prop('disabled',false);
        $("#view").prop('disabled',false);
    }

    ondblClickRow(rowId){
        this.switchToInstanceDetails(rowId);
    }

    viewInstanceDetails(event){
        event.preventDefault();
        let selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        this.switchToInstanceDetails(selRowId);
    }

    switchToInstanceDetails(selectedRow){
        let rowData = $(this.gridEl).getRowData(selectedRow);
        let instanceDetailIdToOpen=rowData['id'];
        const eventValues={
            detailPage: 'ViewableInstanceDetailView',
            payload:{
                instanceId:instanceDetailIdToOpen,
                parentFormId:this.model.get('formId')
            }
        };
        eventBus.trigger(constants.SWITCH_DETAIL_FORM,eventValues);
    }

    render() {
        this.onRender();
        var gridData = this.model.get('gridData');

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        let gridObject = util.getGridObject(self);
        $(self.gridEl).jqGrid(gridObject);
        $(self.gridEl).jqGrid("clearGridData", true);

        if (gridData) {
            gridData.forEach(function (value, index) {
                var newRow = {
                    'id': value['@Id'],
                    'name': value['@Name'],
                    'attentionLevel': util.getAttentionLevel(value['@UserAttentionLevel']),
                    'anyone': util.getAttentionLevel(value['@OtherAttentionLevel']),
                    'stage': value["@StageName"],
                    'status': value["@IsClosed"] === 'False' ? 'Open' : 'Closed',
                    'formInstanceId' : value["@FormInstanceId"]
                };

                $(self.gridEl).addRowData(index, newRow);//
            });
        }

        if (this.config) {
            if (this.config.showTitle) {
                this.$el.find('.propTitle').removeClass('hide');
            }
        }

         console.log("This is the Viewable Instance Model",this.model);

        // If Form Instances, show panel #instance-section

        if (this.model.get('gridData') && this.model.get('gridData').length > 0) {
            $('#instanceSearch').removeClass('hide');
        }

        // Choosing the status value stored in the model.
        $('select[name="status"]').val(this.model.get('search-status') || -1);

        // Selecting the correct value chosen on rendering.
        // As the model doesnt save the ".5" we need to see if the OrHigher attribute was saved into the model
        // so we can select it.
        let attentionLevelElement = $('select[name="attentionLevel"]');
        let otherAttentionLevelElement = $('select[name="otherAttentionLevel"]');

        this.model.get('search-attentionLevelOrHigher')
            ? attentionLevelElement.val(this.model.get('search-attentionLevel') + '.5')
            : attentionLevelElement.val(this.model.get('search-attentionLevel') || -1);

        this.model.get('search-otherAttentionLevelOrHigher')
            ? otherAttentionLevelElement.val(this.model.get('search-otherAttentionLevel') +'.5')
            : otherAttentionLevelElement.val(this.model.get('search-otherAttentionLevel') || -1);

        // Removing the "%" wildcard as the UI doesn't need to display this character.
        if(this.model.get('search-instanceName')) {
            $('input[name="instanceName"]').val(this.model.get('search-instanceName').replace('%', ''));
        }


        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        this.$el.css('cursor', 'default');
        return this;
    }

}

export default ViewableInstanceDetailView;

